<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import UFMunicipio from '@/components(new)/UI/Forms/FormulariosProntos/UFMunicipio/UFMunicipio.vue'
import { opcoesSexo, opcoesEstadoCivil, opcoesRegimeDeBens } from '@/libs/constants/proprietario'

export default {
  mixins: [onlyInputNumbers],
  components: {
    TitleWithRow,
    InputSelect,
    AppInputDouble,
    Label,
    UFMunicipio
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    estadoCivil: {
      type: String,
      default: null
    },
    rendaFamiliar: {
      type: Number,
      default: null
    },
    nome: {
      type: String,
      default: null
    },
    regimeBens: {
      type: String,
      default: null
    },
    cpf: {
      type: String,
      default: null
    },
    sexo: {
      type: String,
      default: null
    },
    municipioId: {
      type: [Number, Object],
      default: null
    },
    municipioNome: {
      type: String,
      default: null
    },
    UF: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      opcoesSexo,
      opcoesEstadoCivil,
      opcoesRegimeDeBens
    }
  },
  methods: {
    updateEstadoCivil (val) {
      this.$emit('update:estadoCivil', val)
      this.$emit('update:regimeBens', null)
    },
    updateRendaFamiliar (val) {
      this.$emit('update:rendaFamiliar', val)
    },
    updateNome (val) {
      this.$emit('update:nome', val)
    },
    updateRegimeDeBens (val) {
      this.$emit('update:regimeBens', val)
    },
    updateCpf (val) {
      this.$emit('update:cpf', val)
    },
    updateSexo (val) {
      this.$emit('update:sexo', val)
    },
    updateMunicipioId (val) {
      this.$emit('update:municipioId', val)
    },
    updateMunicipioNome (val) {
      this.$emit('update:municipioNome', val)
    },
    updateUF (val) {
      this.$emit('update:UF', val)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Cônjuge:" />
    <el-row>
      <InputSelect
        label="Estado civil"
        :value="estadoCivil"
        @input="updateEstadoCivil"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="opcoesEstadoCivil"
        :nomeAba="nomeAba"
        :widthColumn="6"
      />
      <el-col :span="6" class="ml-forms">
        <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Renda familiar'">
          <Label label="Renda familiar" :obrigatorio="true" />
          <AppInputDouble
            :class="{'input erro' : errors.length}"
            name="Renda familiar"
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend="true"
            appendText="R$"
            :value="rendaFamiliar"
            @input="updateRendaFamiliar"
          />
          <span class="help erro" style="margin-left: 1.2rem">{{ errors[0] }}</span>
        </validation-provider>
      </el-col>
    </el-row>

    <div v-if="estadoCivil === 'CASADO' || estadoCivil === 'UNIAO_ESTAVEL'">
      <TitleWithRow title="Dados do Cônjuge" />
      <el-row>
        <validation-provider rules="required" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Nome completo do cônjuge'">
          <el-col :span="13">
            <Label label="Nome completo do cônjuge" :obrigatorio="true" />
            <el-input
              name="Nome completo do cônjuge"
              placeholder="Digite o nome completo do cônjuge"
              clearable
              :class="{'input erro' : errors.length}"
              :value="nome"
              @input="updateNome"
            />
            <span class="help erro"> {{ errors[0] }}</span>
          </el-col>
        </validation-provider>
      </el-row>
      <el-row>
        <InputSelect
          label="Regime de bens"
          :value="regimeBens"
          @input="updateRegimeDeBens"
          :obrigatorio="true"
          rulesInput="required"
          :opcoes="opcoesRegimeDeBens"
          :nomeAba="nomeAba"
          :widthColumn="6"
        />
        <validation-provider rules="required|cpf" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/CPF do cônjuge'">
          <el-col :span="6" class="ml-forms">
            <Label label="CPF do cônjuge" :obrigatorio="true" />
            <el-input
              name="CPF do cônjuge"
              v-mask="'###.###.###-##'"
              placeholder="000.000.000-00"
              clearable
              :class="{'input erro' : errors.length}"
              :value="cpf"
              @input="updateCpf"
            />
            <span class="help erro"> {{ errors[0] }}</span>
          </el-col>
        </validation-provider>
      </el-row>
      <el-row>
        <InputSelect
        label="Sexo"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        rulesInput="required"
        :opcoes="opcoesSexo"
        :widthColumn="13"
        :value="sexo"
        @input="updateSexo"
      />
      </el-row>
      <el-row>
        <UFMunicipio
          class="mt-2"
          :nomeAba="nomeAba"
          :municipioId="municipioId"
          :UF="UF"
          :ufObrigatorio="true"
          :municipioObrigatorio="true"
          @update:municipioId="updateMunicipioId"
          @update:UF="updateUF"
          @update:municipioNome="updateMunicipioNome"
        />
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_utilities.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/DadosConjuge/DadosConjuge.vue